import { Button } from '@mui/material'
import React from 'react'

interface SmallPlusButtonProps {
    onClick: () => void
    extraSmall?: boolean
}

const SmallPlusButton: React.FC<SmallPlusButtonProps> = ({ onClick, extraSmall }: SmallPlusButtonProps) => {
    const size = extraSmall ? '29px' : '36px'

    return (
        <Button
            style={{
                maxWidth: size,
                maxHeight: size,
                minWidth: size,
                minHeight: size,
            }}
            variant='contained'
            onClick={onClick}
        >
            +
        </Button>
    )
}

export default SmallPlusButton